import http from "../index";

// * 机构详情
export const infoOrg = (params) => {
	return http.post(`/api/v1/org/admin/infoOrg`, params);
};

// * 修改机构信息
export const editOrg = (params) => {
	return http.post(`/api/v1/org/admin/editOrg`, params);
};

// * 修改机构信息
export const addPlayer = (params) => {
	return http.post(`/api/v1/org/admin/addPlayer`, params);
};

// * 课程类别
export const courseCategoryList = (params) => {
	return http.post(`/api/v1/union/courseCategoryList`, params);
};

// 参赛者列表
export const listPlayer = (params) => {
	return http.post(`/api/v1/org/admin/listPlayer`, params);
};
// 删除参赛者
export const delPlayer = (params) => {
	return http.post(`/api/v1/org/admin/delPlayer`, params);
};
// 参赛者详情
export const infoPlayer = (params) => {
	return http.post(`/api/v1/org/admin/infoPlayer`, params);
};
// 修改参赛者信息
export const editPlayer = (params) => {
	return http.post(`/api/v1/org/admin/editPlayer`, params);
};
// 重置密码
export const resetPassword = (params) => {
	return http.post(`/api/v1/union/resetPassword`, params);
};
// 上传课程
export const addCourse = (params) => {
	return http.post(`/api/v1/org/admin/addCourse`, params);
};
// 课程列表
export const listCourse = (params) => {
	return http.post(`/api/v1/org/admin/listCourse`, params);
};
// 课程详情
export const infoCourse = (params) => {
	return http.post(`/api/v1/org/admin/infoCourse`, params);
};
// 删除课程
export const delCourse = (params) => {
	return http.post(`/api/v1/org/admin/delCourse`, params);
};
// 修改课程
export const editCourse = (params) => {
	return http.post(`/api/v1/org/admin/editCourse`, params);
};
// 申报结束时间
export const isCanOnlineUpload = (params) => {
	return http.post(`/api/v1/union/isCanOnlineUpload`, params);
};


